import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Jumbotron, Form, Col, Table, Button, Alert, Row } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import config from '../../../config';
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";
//import Numeroaletras from '../../../middleware/numbertoletter';
import ModalConfirm from '../../subcomponent/modalConfirm';
import funciones from '../../../middleware/funciones';
import SearchItem from '../../subcomponent/searchItem';
import SearchClient from '../../subcomponent/searchClient';
import ModalImpresion from '../../subcomponent/modalImpresion';

class EditPedidos extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('vendedor');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            currentUser,
            tipo: currentUserType,
            showAlert: false,
            numeroDocumento: 0,
            clientes: [],
            prefijos: [],
            forma_pago: [],
            vendedores: [],
            retenciones: [],
            bodegas: [],
            PREFIJO: "",
            FORMA_PAGO: "",
            NUMERO_FACTURA: 0,
            CLIENTE: "",
            FECHA_ENTREGA: "",
            ID_CLIENTES: 0,
            cod_lista: "",
            form_pagoc: "",
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            VENDEDOR_SELECTED: "",
            OBSERVACION_FACTURA: "",
            ORDEN_COMPRA: "",
            ID_DETALLE: "",
            SHOW_DETAIL: false,
            data_items: [],
            detalle_factura: [],
            data_cliente: [],
            pedidos: [],
            detalle: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            showPress: false,
            mensajeImp: ''
        };
    }
    componentDidMount() {
        this.initFactura();
        let id_pedido = "";
        const { search } = this.props.location;
        const pedidoEdicion = search.replace('?', '');
        id_pedido = pedidoEdicion;

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        ////console.log(id_pedido);
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/invoice/infoInvoice/' + pedidoEdicion, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datosPed = data.data;
                    const cabecera = datosPed[0];
                    const detalle = datosPed[1];
                    const FECHA_ENTREGA = funciones.formatDate(cabecera[0]["FECHA_VENCIMIENTO_DOCUMENTO"]);
                    const ID_CLIENTES = detalle[0]["ID_CLIENTES"];
                    //console.log(cabecera[0]["CONDICION_PAGO"])
                    const { forma_pago } = this.state;
                    console.log(forma_pago)

                    this.setState({
                        FECHA_ENTREGA,
                        ID_CLIENTES,
                        CODIGO_EMPRESA: cabecera[0]["CODIGO_EMPRESA"],
                        CENTRO_OPERACION: cabecera[0]["CENTRO_OPERACION"],
                        NUMERO_FACTURA_CABECERA: cabecera[0]["NUMERO_FACTURA_CABECERA"],
                        TIPO_DOCUMENTO_CABECERA: cabecera[0]["TIPO_DOCUMENTO_CABECERA"],
                        NUMERO_REMISION: cabecera[0]["NUMERO_REMISION"],
                        NUMERO_PEDIDO: cabecera[0]["NUMERO_PEDIDO"],
                        ORDEN_COMPRA: cabecera[0]["DOCUMENTO_ALTERNO"],
                        ID_TRANSACCION: cabecera[0]["ID_TRANSACCION"],
                        DOCUMENTO_CLIENTE: cabecera[0]["DOCUMENTO_CLIENTE"],
                        DIGITO_VERIFICACION_CLIENTE: cabecera[0]["DIGITO_VERIFICACION_CLIENTE"],
                        TIPO_IDENTIFICACION_CLIENTE: cabecera[0]["TIPO_IDENTIFICACION_CLIENTE"],
                        NOMBRE_CLIENTE: cabecera[0]["NOMBRE_CLIENTE"],
                        DIRECCION_CLIENTE: cabecera[0]["DIRECCION_CLIENTE"],
                        DEPARTAMENTO_CLIENTE: cabecera[0]["DEPARTAMENTO_CLIENTE"],
                        CODIGO_POSTAL: cabecera[0]["CODIGO_POSTAL"],
                        CIUDAD_CLIENTE: cabecera[0]["CIUDAD_CLIENTE"],
                        CODIGO_DEPARTAMENTO_CLIENTE: cabecera[0]["CODIGO_DEPARTAMENTO_CLIENTE"],
                        CODIGO_CIUDAD_CLIENTE: cabecera[0]["CODIGO_CIUDAD_CLIENTE"],
                        TELEFONO_CLIENTE: cabecera[0]["TELEFONO_CLIENTE"],
                        EMAIL_CLIENTE: cabecera[0]["EMAIL_CLIENTE"],
                        VENDEDOR: cabecera[0]["VENDEDOR"],
                        FORMA_PAGO: cabecera[0]["ID_FORMAS_PAGO"],
                        FECHA_DOCUMENTO: todayFormat,
                        FECHA_DOCUMENTO_ALTERNO: cabecera[0]["FECHA_DOCUMENTO_ALTERNO"],
                        PORCENTAJE_IVA: cabecera[0]["PORCENTAJE_IVA"],
                        PORCENTAJE_IMPOCONSUMO: cabecera[0]["PORCENTAJE_IMPOCONSUMO"],
                        TOTAL_BRUTO: cabecera[0]["TOTAL_BRUTO"],
                        TOTAL_DESCUENTO_LINEA: cabecera[0]["TOTAL_DESCUENTO_LINEA"],
                        TOTAL_DESCUENTO_GLOBAL: cabecera[0]["TOTAL_DESCUENTO_GLOBAL"],
                        TOTAL_IVA: cabecera[0]["TOTAL_IVA"],
                        TOTAL_IMPOCONSUMO: cabecera[0]["TOTAL_IMPOCONSUMO"],
                        TOTAL_RETENCION: cabecera[0]["TOTAL_RETENCION"],
                        RET_IVA: cabecera[0]["RET_IVA"],
                        RET_ICA: cabecera[0]["RET_ICA"],
                        RET_FUENTE: cabecera[0]["RET_FUENTE"],
                        RET_OTROS: cabecera[0]["RET_OTROS"],
                        SUBTOTAL: cabecera[0]["SUBTOTAL"],
                        TOTAL_VENTA: cabecera[0]["TOTAL_VENTA"],
                        CONDICION_PAGO: cabecera[0]["CONDICION_PAGO"],
                        VALOR_LETRAS: cabecera[0]["VALOR_LETRAS"],
                        TASA_MONEDA: cabecera[0]["TASA_MONEDA"],
                        TIPO_MONEDA: cabecera[0]["TIPO_MONEDA"],
                        OBSERVACION_FACTURA: cabecera[0]["OBSERVACION1"],
                        OBSERVACION2: cabecera[0]["OBSERVACION2"],
                        BARRIO: cabecera[0]["BARRIO"],
                        CODIGO_VENDEDOR: cabecera[0]["CODIGO_VENDEDOR"],
                        detalle,
                        // ID_DETALLE: detalle[0]["ID_DETALLE"],
                        // CODIGO_EMPRESA_DETALLE: detalle[0]["CODIGO_EMPRESA"],
                        // CENTRO_OPERACION_DETALLE: detalle[0]["CENTRO_OPERACION"],
                        // NUMERO_FACTURA_DETALLE: detalle[0]["NUMERO_FACTURA_DETALLE"],
                        // TIPO_DOCUMENTO_DETALLE: detalle[0]["TIPO_DOCUMENTO_DETALLE"],
                        // INDICE_ITEM: detalle[0]["INDICE_ITEM"],
                        // ITEM_ID: detalle[0]["ITEM_ID"],
                        // ITEM_DESCRIPCION: detalle[0]["ITEM_DESCRIPCION"],
                        // SERIAL: detalle[0]["SERIAL"],
                        // UNIDAD_MEDIDA: detalle[0]["UNIDAD_MEDIDA"],
                        // CANTIDAD_1: detalle[0]["CANTIDAD_1"],
                        // CANTIDAD_2: detalle[0]["CANTIDAD_2"],
                        // PRECIO_UNITARIO_DETALLE: detalle[0]["PRECIO_UNITARIO_DETALLE"],
                        // TOTAL_BRUTO_DETALLE: detalle[0]["TOTAL_BRUTO_DETALLE"],
                        // DESCUENTO_LINEA_DETALLE: detalle[0]["DESCUENTO_LINEA_DETALLE"],
                        // IVA_DETALLE: detalle[0]["IVA_DETALLE"],
                        // IMPOCONSUMO_DETALLE: detalle[0]["IMPOCONSUMO_DETALLE"],
                        // PORCENTAJE_IVA_DETALLE: detalle[0]["PORCENTAJE_IVA_DETALLE"],
                        // PORCENTAJE_IMPOCONSUMO_DETALLE: detalle[0]["PORCENTAJE_IMPOCONSUMO_DETALLE"],
                        // PORCENTAJE_DESCUENTO_DETALLE: detalle[0]["PORCENTAJE_DESCUENTO_DETALLE"],
                        // OBSERVACION_ITEM: detalle[0]["OBSERVACION_ITEM"],
                        // BODEGA: detalle[0]["BODEGA"]
                    });
                    this.changeCliente();
                    //changeClienteCallback();
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
        this.setState({ id_pedido });
    }

    initFactura = () => {
        const { currentUser } = this.state;
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': 'PE',
                'currentUser': currentUser,
            }
        }
        fetch(config.servBackEnd + '/invoice/', datasend).then(response => response.json())
            .then(data => {
                const cData = data.data;
                const clientes = cData[0];
                const prefijos = cData[5];
                const forma_pago = cData[2];
                const vendedores = cData[3];
                const retenciones = cData[4];
                const bodegas = cData[6];
                this.setState({
                    clientes,
                    prefijos,
                    forma_pago,
                    vendedores,
                    retenciones,
                    // PREFIJO: "",
                    // FORMA_PAGO: "",
                    // NUMERO_FACTURA: 0,
                    // CLIENTE: "",
                    // FECHA_ENTREGA: "",
                    // SHOW_DETAIL: false,
                    bodegas
                });
                //  this.clearItem();
            });
    }
    changePrefijo = ({ target }) => {
        const numero = target.selectedOptions[0].title;
        let showDetail = false;
        if (numero && this.state.CLIENTE !== "") {
            showDetail = true
        }
        this.setState({
            PREFIJO: target.value,
            NUMERO_FACTURA: numero,
            SHOW_DETAIL: showDetail,
            showAlert: false
        });

    }

    changeCantidad = ({ target }, position) => {
        const newDetalle = this.state.detalle_factura;
        let { value } = target;
        const { name } = target;
        if (name === "DESCUENTO" && value > 100) value = 100;
        newDetalle.forEach((element, index) => {
            if (position === index) {
                element[name] = value;
            };
        });
        this.setState({ detalle_factura: newDetalle });
        this.calcTotales();
    }

    calcTotales = () => {
        const newDetalle = this.state.detalle_factura;
        const { retenciones } = this.state;
        const { data_cliente } = this.state;
        let RENTA = 0;
        let RETEIVA = 0;
        let RETEICA = 0;
        let RETEOTROS = 0;
        let TOTAL_BRUTO = 0;
        let RETENCION = 0;
        let TOTAL_IVA = 0;
        let SUBTOTAL = 0;
        let TOTAL_DESCUENTOS = 0;
        let TOTAL_PAGAR = 0;
        newDetalle.forEach(element => {
            element.TOTAL = element.CANTIDAD * element.VALOR_UNI;
            element.VALOR_DCTO = element.TOTAL * element.DESCUENTO / 100;
            element.VALOR_IVA = (element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_IVA / 100;
            TOTAL_BRUTO += element.TOTAL;
            TOTAL_IVA += element.VALOR_IVA;
            TOTAL_DESCUENTOS += element.VALOR_DCTO;
            SUBTOTAL = TOTAL_BRUTO - TOTAL_DESCUENTOS;
            TOTAL_PAGAR = TOTAL_BRUTO - TOTAL_DESCUENTOS + TOTAL_IVA;
        });

        if (data_cliente[0].LIQUIDA_RENTA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "1") {
                    RENTA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RENTA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEIVA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "2") {
                    RETEIVA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? TOTAL_IVA * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEIVA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEICA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "3") {
                    RETEICA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEICA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEOTROS) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "4") {
                    RETEOTROS += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEOTROS;
                }
            });
        }

        TOTAL_PAGAR -= RETENCION;

        const newTotal = {
            TOTAL_BRUTO,
            RETENCION,
            TOTAL_IVA,
            SUBTOTAL,
            TOTAL_DESCUENTOS,
            TOTAL_PAGAR
        }

        this.setState({
            RENTA,
            RETEIVA,
            RETEICA,
            RETEOTROS,
            detalle_factura: newDetalle,
            totales: newTotal
        })
    }

    changeItem = (selectItem) => {
        const newdetalle = this.state.detalle_factura;
        const { data_items } = this.state;
        const { data_cliente } = this.state;
        const infoCliente = data_cliente[0];
        let currentItem = [];
        let control = true;
        let cont = 0;

        while (control) {
            const item = data_items[cont];
            if (selectItem.ID_ITEMS.toString() === item.ID_ITEMS.toString()) {
                currentItem = item;
                control = false;
            }
            cont++;
        }

        newdetalle.push({
            ID_ITEMS: selectItem.ID_ITEMS,
            REFERENCIA_ITEM: selectItem.REFERENCIA_ITEM,
            DESCRIPCION_ITEM: selectItem.DESCRIPCION_ITEM,
            CANTIDAD: (selectItem.CANTIDAD_1 || 1),
            DESCUENTO: (selectItem.PORCENTAJE_DESCUENTO_DETALLE || 0),
            VALOR_UNI: currentItem.PRECIO,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            OBS_ITEM: "",
            BODEGA: "",
            PORCENTAJE_IVA: (infoCliente.LIQUIDA_IVA) ? currentItem.IVA_ITEM : 0,
            TOTAL: 0
        });

        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
    }

    removeitem = (index) => {
        let newData = this.state.detalle_factura;

        newData.splice(index, 1);
        this.setState({ detalle_factura: newData });
        this.calcTotales();
    }

    changeCliente = () => {
        //const { prefijos } = this.state;
        const value = this.state.ID_CLIENTES;
        const { detalle } = this.state;
        let showDetail = false;
        // prefijos.forEach(data => {
        // this.setState({ PREFIJO: data.PREFIJO });
        //});



        if (value.toString() !== '0') {
            if (this.state.PREFIJO !== "") showDetail = true;
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/invoice/detail/' + value, datasend).then(response => response.json())
                .then(data => {
                    const cData = data.data;
                    const cCliente = cData[0];
                    const cItems = cData[1];
                    const vend = cCliente[0]["VENDEDOR_ASOCIADO"];
                    const list = cCliente[0]["LISTA_CLIENTE"];
                    const forpago = cCliente[0]["FORMA_PAGO_CLIENTE"];
                    const prefijo = cCliente[0]["PEDIDO"];
                    this.setState({
                        CLIENTE: value,
                        cod_lista: list,
                        form_pagoc: forpago,
                        PREFIJO: prefijo,
                        SHOW_DETAIL: showDetail,
                        data_items: cItems,
                        data_cliente: cCliente,
                        VENDEDOR_SELECTED: vend,
                        totales: {
                            TOTAL_BRUTO: 0,
                            RETENCION: 0,
                            TOTAL_IVA: 0,
                            SUBTOTAL: 0,
                            TOTAL_DESCUENTOS: 0,
                            TOTAL_PAGAR: 0
                        },
                        RENTA: 0,
                        RETEIVA: 0,
                        RETEICA: 0,
                        RETEOTROS: 0,
                        detalle_factura: []
                    });
                    detalle.forEach(element => {
                        this.changeItem(element);
                    });
                });
        } else {
            //console.log("Seleccione un cliente");
        };

    }

    clearItem = () => {
        this.setState({
            detalle_factura: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0
        })

    }

    saveInvoice = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();

        let id_pedido = "";
        const { search } = this.props.location;
        const pedidoEdicion = search.replace('?', '');
        id_pedido = pedidoEdicion;

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        //const cliente = this.state.data_cliente[0];
        //const { totales } = this.state;
        const { forma_pago } = this.state;
        //const { vendedores } = this.state;
        const { detalle_factura } = this.state;
        //const valorTexto = Numeroaletras(totales.TOTAL_PAGAR);
        let currentForma = []

        forma_pago.forEach(element => {
            if (element.ID_FORMAS_PAGO.toString() === this.state.FORMA_PAGO.toString()) {
                currentForma = element;
            }
        });

        /*let currentVend = []
        vendedores.forEach(element => {
        if (element.ID_USUARIO.toString() === this.state.VENDEDOR_SELECTED.toString()) {
        currentVend = element;
        }
        }); */
        //const subtotal_send = totales.SUBTOTAL + totales.TOTAL_DESCUENTOS + totales.TOTAL_IVA;
        const Cabecera = {
            ID_EMPRESA: this.state.empresa,
            CODIGO_EMPRESA: this.state.CODIGO_EMPRESA,
            CENTRO_OPERACION: this.state.CENTRO_OPERACION,
            NUMERO_FACTURA_CABECERA: this.state.NUMERO_FACTURA_CABECERA,
            TIPO_DOCUMENTO_CABECERA: this.state.TIPO_DOCUMENTO_CABECERA,
            NUMERO_REMISION: this.state.NUMERO_REMISION,
            NUMERO_PEDIDO: this.state.NUMERO_PEDIDO,
            DOCUMENTO_ALTERNO: this.state.ORDEN_COMPRA,
            ID_TRANSACCION: this.state.ID_TRANSACCION,
            DOCUMENTO_CLIENTE: this.state.DOCUMENTO_CLIENTE,
            DIGITO_VERIFICACION_CLIENTE: this.state.DIGITO_VERIFICACION_CLIENTE,
            TIPO_IDENTIFICACION_CLIENTE: this.state.TIPO_IDENTIFICACION_CLIENTE,
            NOMBRE_CLIENTE: this.state.NOMBRE_CLIENTE,
            DIRECCION_CLIENTE: this.state.DIRECCION_CLIENTE,
            DEPARTAMENTO_CLIENTE: this.state.DEPARTAMENTO_CLIENTE,
            CODIGO_POSTAL: this.state.CODIGO_POSTAL,
            CIUDAD_CLIENTE: this.state.CIUDAD_CLIENTE,
            CODIGO_DEPARTAMENTO_CLIENTE: this.state.CODIGO_DEPARTAMENTO_CLIENTE,
            CODIGO_CIUDAD_CLIENTE: this.state.CODIGO_CIUDAD_CLIENTE,
            TELEFONO_CLIENTE: this.state.TELEFONO_CLIENTE,
            EMAIL_CLIENTE: this.state.EMAIL_CLIENTE,
            VENDEDOR: this.state.VENDEDOR,
            FECHA_DOCUMENTO: todayFormat,
            FECHA_VENCIMIENTO_DOCUMENTO: this.state.FECHA_ENTREGA,
            FECHA_DOCUMENTO_ALTERNO: this.state.FECHA_DOCUMENTO_ALTERNO,
            PORCENTAJE_IVA: this.state.PORCENTAJE_IVA,
            PORCENTAJE_IMPOCONSUMO: this.state.PORCENTAJE_IMPOCONSUMO,
            TOTAL_BRUTO: this.state.TOTAL_BRUTO,
            TOTAL_DESCUENTO_LINEA: this.state.TOTAL_DESCUENTO_LINEA,
            TOTAL_DESCUENTO_GLOBAL: this.state.TOTAL_DESCUENTO_GLOBAL,
            TOTAL_IVA: this.state.TOTAL_IVA,
            TOTAL_IMPOCONSUMO: this.state.TOTAL_IMPOCONSUMO,
            TOTAL_RETENCION: this.state.TOTAL_RETENCION,
            RET_IVA: this.state.RET_IVA,
            RET_ICA: this.state.RET_ICA,
            RET_FUENTE: this.state.RET_FUENTE,
            RET_OTROS: this.state.RET_OTROS,
            SUBTOTAL: this.state.SUBTOTAL,
            TOTAL_VENTA: this.state.TOTAL_VENTA,
            CONDICION_PAGO: currentForma.DESCRIPCION_FORMA_PAGO,
            VALOR_LETRAS: this.state.VALOR_LETRAS,
            TASA_MONEDA: this.state.TASA_MONEDA,
            TIPO_MONEDA: this.state.TASA_MONEDA,
            OBSERVACION1: this.state.OBSERVACION_FACTURA,
            OBSERVACION2: this.state.OBSERVACION2,
            BARRIO: this.state.BARRIO_CLIENTE,
            CODIGO_VENDEDOR: this.state.CODIGO_VENDEDOR,
            ESTADO_PEDIDO: "0"
        }


        let Detalle = []

        detalle_factura.forEach((element, index) => {
            if (element.DESCRIPCION_ITEM !== "") {
                Detalle.push(
                    {
                        ID_EMPRESA: this.state.empresa,
                        CODIGO_EMPRESA: this.state.CODIGO_EMPRESA,
                        CENTRO_OPERACION: this.state.CENTRO_OPERACION,
                        NUMERO_FACTURA_DETALLE: this.state.NUMERO_FACTURA_CABECERA,
                        TIPO_DOCUMENTO_DETALLE: this.state.TIPO_DOCUMENTO_CABECERA,
                        INDICE_ITEM: (index + 1),
                        ITEM_ID: element.ID_ITEMS,
                        ITEM_DESCRIPCION: element.DESCRIPCION_ITEM,
                        SERIAL: element.SERIAL,
                        UNIDAD_MEDIDA: 'UND',
                        CANTIDAD_1: element.CANTIDAD,
                        CANTIDAD_2: element.CANTIDAD,
                        PRECIO_UNITARIO_DETALLE: element.VALOR_UNI,
                        TOTAL_BRUTO_DETALLE: element.TOTAL,
                        DESCUENTO_LINEA_DETALLE: 0,
                        IVA_DETALLE: element.VALOR_IVA,
                        IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_IVA_DETALLE: element.IVA_DETALLE,
                        PORCENTAJE_IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_DESCUENTO_DETALLE: 0,
                        OBSERVACION_ITEM: element.OBS_ITEM,
                        BODEGA: element.BODEGA
                    }
                )
            }
        });
        const factura = {
            Tipo: "P",
            Cabecera,
            Detalle,
            id_pedido
        }

        const datasend = {
            method: 'POST',
            body: JSON.stringify(factura),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        };

        fetch(config.servBackEnd + '/invoice/editInvoice', datasend).then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    const { id } = data;
                    this.setState({ showAlert: true, numeroDocumento: data.DOCUMENTO_CREADO, showPress: true, id });
                }
            });
    }

    createRetenciones = () => {
        let cont = 0;
        let children = [];
        const { retenciones } = this.state;
        while (cont < 4) {
            if (retenciones[cont]) {
                switch (retenciones[cont].TIPO_RETENCION) {
                    case "1":
                        children.push(<td key={'tr'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RENTA}</td>);
                        break;
                    case "2":
                        children.push(<td key={'ti'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEIVA}</td>);
                        break;
                    case "3":
                        children.push(<td key={'tc'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEICA}</td>);
                        break;
                    case "4":
                        children.push(<td key={'to'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEOTROS}</td>);
                        break;
                    default:
                        children.push(<td key={'t' + cont} ></td>);
                };
            }
            else {
                children.push(<td key={'t' + cont} ></td>);
            }
            cont += 1;
        }
        return children;
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    changeBodegaItem = ({ currentTarget }, i) => {
        const newDetalle = this.state.detalle_factura;
        const id = 'selectbod' + i;
        const selectBox = document.getElementById(id);
        const { value } = selectBox;
        newDetalle.forEach((element, index) => {
            if (i === index) {
                element.BODEGA = value;
            };
        });
        this.setState({ detalle_factura: newDetalle });

    }

    hideModalImp = () => {
        this.setState({ showPress: false, mensajeImp: "" });
    }

    impresionPDF = () => {
        const { id } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/files/getpdfpedido/' + id, datasend)
            .then((res) => {
                if (res.ok) return res.blob();
            }).then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function () {
                    window.setTimeout(function () {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                })
            .catch((err) => {
                console.error(err);
            });
    }

    enviarCorreo = () => {
        const { id } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/files/createsendorder/' + id, datasend)
            .then(data => {
                //console.log(data);
                this.setState({ mensajeImp: "Correo Enviado Correctamente" });
            });
    }

    render() {
        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        const mensajeConfirm = "¿Está seguro que desea actualizar el pedido?";
        const { prefijos } = this.state;
        const { clientes } = this.state;
        const { forma_pago } = this.state;
        const { vendedores } = this.state;
        const { detalle_factura } = this.state;
        const { cod_lista } = this.state;
        const { data_items } = this.state;
        const { totales } = this.state;
        const { currentUser } = this.state;
        const { showAlert } = this.state;
        //const { bodegas } = this.state;
        const changeCantidad = this.changeCantidad;
        const removeitem = this.removeitem;
        const clearItem = this.clearItem;
        const saveInvoice = this.saveInvoice;
        //const changeBodegaItem = this.changeBodegaItem;
        //const idClient = sessionStorage.getItem('_id');
        return (

            <div className="contenedor">
                <iframe id="pdf-frame"></iframe>

                <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                <ModalImpresion hideModalImp={this.hideModalImp} impresionPDF={this.impresionPDF} enviarCorreo={this.enviarCorreo} showPress={this.state.showPress} mensaje={this.state.mensajeImp}></ModalImpresion>
                <Jumbotron style={style}>
                    <h1>Edición de Pedidos</h1>
                </Jumbotron>
                {showAlert &&
                    <Alert variant='success'>
                        El documento se actualizó satisfactoriamente.
                    </Alert>
                }
                <Form onSubmit={saveInvoice}>
                    <Form.Row>

                        {this.state.tipo === "C" && <Form.Row>

                            <Form.Group as={Col} >
                                <Form.Label>TIPO DE DOCUMENTO</Form.Label>
                                <Form.Control value={this.state.PREFIJO} readOnly></Form.Control>
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Label>NUMERO PEDIDO</Form.Label>
                                <Form.Control defaultValue={this.state.NUMERO_FACTURA_CABECERA} readOnly></Form.Control>
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Label>FECHA ENTREGA</Form.Label>
                                <Form.Control type="date" value={this.state.FECHA_ENTREGA} readOnly />
                            </Form.Group>

                        </Form.Row>
                        }

                        {this.state.tipo !== "C" && <Form.Row>
                            <Form.Group as={Col} >
                                <Form.Label>TIPO DOCUMENTO</Form.Label>
                                <Form.Control as="select" onChange={this.changePrefijo} value={this.state.PREFIJO} required>
                                    <option value="">Seleccione</option>
                                    {prefijos.map(function (currentData, index) {
                                        return <option key={'p' + index} title={currentData.ULTIMO_DIGITO + 1} value={currentData.PREFIJO}>{currentData.PREFIJO}</option>;
                                    })}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Label>CLIENTE</Form.Label>
                                <SearchClient data={clientes} client={this.state.NOMBRE_CLIENTE} event={this.changeCliente}></SearchClient>
                            </Form.Group>


                            <Form.Group as={Col} >
                                <Form.Label>FORMA DE PAGO</Form.Label>
                                <Form.Control as="select" onChange={(e) => this.setState({ FORMA_PAGO: e.target.value })} value={this.state.FORMA_PAGO} required >
                                    <option value="">Seleccione</option>
                                    {forma_pago.map(function (currentData, index) {
                                        return <option key={'p' + index} value={currentData.ID_FORMAS_PAGO}>{currentData.DESCRIPCION_FORMA_PAGO}</option>;
                                    })}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group as={Col} >
                                <Form.Label>FECHA ENTREGA</Form.Label>
                                <Form.Control type="date" onChange={e => this.setState({ FECHA_ENTREGA: e.target.value })} value={this.state.FECHA_ENTREGA} required />
                            </Form.Group>

                        </Form.Row>
                        }


                        <Form.Group as={Col} >
                            <Form.Label>ORDEN DE COMPRA</Form.Label>
                            <Form.Control type="text" maxLength="12" onChange={e => this.setState({ ORDEN_COMPRA: e.target.value })} value={this.state.ORDEN_COMPRA} />
                        </Form.Group>
                        {currentUser === "0" && <Form.Group as={Col} >
                            <Form.Label>VENDEDOR</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.setState({ VENDEDOR_SELECTED: e.target.value })} value={this.state.VENDEDOR_SELECTED} required >
                                <option value="">Seleccione</option>
                                {vendedores.map(function (currentData, index) {
                                    return <option key={'p' + index} value={currentData.ID_USUARIO}>{currentData.NOMBRE_COMPLETO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group>}
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>OBSERVACIONES</Form.Label>
                            <Form.Control as="textarea" rows="1" onChange={(e) => this.setState({ OBSERVACION_FACTURA: e.target.value.toUpperCase() })} value={this.state.OBSERVACION_FACTURA} />
                        </Form.Group>
                    </Form.Row>
                    <div>
                        <Button type="submit" disabled={detalle_factura.length === 0}>Guardar</Button>
                        <Button onClick={clearItem} disabled={detalle_factura.length === 0} >Limpiar</Button>
                    </div>

                </Form>
                <div>
                    <Row>
                        <Col sm={3}>
                            <SearchItem data={data_items} event={this.changeItem} ></SearchItem>
                        </Col>
                        <Col sm={9}>
                            <Form id="detailForm">
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            {/* <th>CODIGO</th> */}
                                            <th></th>
                                            <th>REF.</th>
                                            <th>DESCRIPCION</th>
                                            <th>OBSERVACION</th>
                                            <th>CANTIDAD</th>
                                            <th>VALOR UNITARIO</th>
                                            <th>VALOR IVA</th>
                                            <th>TOTAL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detalle_factura.map(function (element, index) {
                                            console.log(element);
                                            return <tr key={'dettr' + index}>
                                                <td>
                                                    <IconContext.Provider value={{ size: "2em" }}>
                                                        <IoIosRemoveCircle onClick={() => removeitem(index)} />
                                                    </IconContext.Provider>
                                                </td>
                                                <td>{element.REFERENCIA_ITEM}</td>
                                                <td>{element.DESCRIPCION_ITEM}</td>
                                                <td> <Form.Control name="OBS_ITEM" type="text" maxLength="200" onChange={(e) => changeCantidad(e, index)} value={element.OBS_ITEM} /></td>
                                                <td> <Form.Control name="CANTIDAD" min="1" type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={element.CANTIDAD} /></td>
                                                <td> <Form.Control name="VALOR_UNI" min="0" type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === "" || cod_lista !== 0} value={element.VALOR_UNI} /></td>
                                                <td className="currSign">{Intl.NumberFormat('es-MX').format(element.VALOR_IVA)}</td>
                                                <td className="currSign">{Intl.NumberFormat('es-MX').format(element.TOTAL)}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </Table>

                                <Table striped bordered hover>
                                    <tfoot>
                                        <tr>
                                            <td>TOTAL BRUTO</td>
                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(totales.TOTAL_BRUTO)}</td>
                                            <td>SUBTOTAL</td>
                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(totales.SUBTOTAL)}</td>
                                            <td>TOTAL IVA</td>
                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(totales.TOTAL_IVA)}</td>
                                            <td>TOTAL</td>
                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(totales.TOTAL_PAGAR)}</td>
                                        </tr>
                                    </tfoot>

                                </Table>
                            </Form>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }
}
export default (EditPedidos);


// WEBPACK FOOTER //
// ./src/components/bussines/pedidos/Editpedidos.jsx